import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatPaginator, PageEvent } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { PontoFidelidade } from 'src/app/models/ponto-fidelidade';
import { CarregandoService } from 'src/app/services/carregando.service';
import { FidelidadePontoService } from 'src/app/services/fidelidade-ponto.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import swal from 'sweetalert2';
import { CadastrarPontosFidelidadeModalComponent } from './cadastrar-pontos-fidelidade-modal/cadastrar-pontos-fidelidade-modal.component';
import { PaginatorService } from 'src/app/services/paginator.service';

// jquery
declare const $: any;
@Component({
  selector: 'app-pontos-fidelidade-modal',
  templateUrl: './pontos-fidelidade-modal.component.html',
  styleUrls: ['./pontos-fidelidade-modal.component.scss']
})
export class PontosFidelidadeModalComponent implements OnInit {

  pontosFiltrados: PontoFidelidade[] = [];
  carregando = true;
  campoOrdenacao = 'produto';
  ordenarDesc = false;
  editavel = true;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  regra;
  public config: PerfectScrollbarConfigInterface = {};

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  constructor(
    public dialogRef: MatDialogRef<PontosFidelidadeModalComponent>, 
    private carregandoService: CarregandoService, 
    public utilitarioService: UtilitarioService,
    private notificacaoService: NotificacaoService, 
    private paginatorService: PaginatorService,
    @Inject(MAT_DIALOG_DATA) public data: any, 
    public dialog: MatDialog, 
    private fidelidadePontoService: FidelidadePontoService) {
    this.regra = data.regra;
  }

  ngOnInit() {
    const pagination = this.paginatorService.consultarPaginacao();
    
    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.buscarPontosFidelidade();
  }

  buscarPontosFidelidade() {
    this.carregandoService.mostra('buscarProdutosFidelidade');

    this.fidelidadePontoService.consultarComPaginacao(this.paginacao.paginaAtual, this.itensPorPagina, this.campoOrdenacao, (this.ordenarDesc ? 'desc' : 'asc'), this.regra).subscribe((data: any) => {
      this.pontosFiltrados = data.itens;

      if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
        this.itensPorPagina = 10;
      }

      this.paginacao.total = data.total;

      this.carregando = false;
      this.carregandoService.esconde('buscarProdutosFidelidade');
    }, (erro) => {
      this.carregandoService.esconde('buscarProdutosFidelidade');
      this.notificacaoService.erro(erro);
    });
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarPontosFidelidade();
  }

  fechar() {
    this.dialogRef.close();
  }

  excluirItem(idPonto) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir o Ponto?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluirItem');
        this.fidelidadePontoService.excluir(idPonto).subscribe(resp => {
          this.notificacaoService.sucesso('Ponto excluído com sucesso!!!');
          this.carregandoService.esconde('excluirItem');
          this.buscarPontosFidelidade();
        }, (erro) => {
          this.carregandoService.esconde('excluirItem');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  novoItem() {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(CadastrarPontosFidelidadeModalComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: { regra: this.regra },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: PontoFidelidade) => {
      if (result) {
        this.buscarPontosFidelidade();
      }
    });
  }

  editarItem(idPonto) {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(CadastrarPontosFidelidadeModalComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: { idPonto: idPonto },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: PontoFidelidade) => {
      if (result) {
        this.buscarPontosFidelidade();
      }
    });
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }
}